export default __webpack_public_path__ + "static/media/3FA13306-9762-417B-B6D1-58626342D3C8_1_105_c.0aec1abb.jpeg";